import { render, staticRenderFns } from "./VueMultiselect.vue?vue&type=template&id=0a74ce0a&"
import script from "./VueMultiselect.vue?vue&type=script&lang=ts&"
export * from "./VueMultiselect.vue?vue&type=script&lang=ts&"
import style0 from "./VueMultiselect.vue?vue&type=style&index=0&id=0a74ce0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports